<template>
  <div id="mainWps" class="wps-wrap">

  </div>
</template>

<script setup>
/*
 * WPS表格组件---现在仅用于做题逻辑。预览的在freeViewOffice.vue里面
 */
const props = defineProps({
})

let instance = null

function initWps(fileId, customArgs) {
  nextTick(() => {
    const config = {
      officeType: WebOfficeSDK.OfficeType.Spreadsheet,
      mount: '#mainWps',
      appId: (location.host.indexOf('localhost') > -1 || location.host.indexOf('wwwpre') > -1) ?'SX20241219TAAFZZ' : 'AK20241226DJGDWQ',
      fileId: toRaw(fileId),
      //token: 'abc',
      customArgs: toRaw(customArgs), // 参数，会传入到后端
    }
    console.log('传入wps配置信息', config)
    instance = WebOfficeSDK.init(config)
  })
}

defineExpose(({
  initWps
}))

onBeforeUnmount(() => { // 销毁实例
  if (instance != null) {
    instance.destroy()
    instance = null
  }
})
</script>

<style scoped lang="scss">
.wps-wrap {
  height: 300px;
}
</style>
